import React from "react"

interface ImageContainerProps {
    style?: React.CSSProperties,
    imageUrl?: string | null,
    alt: string,
}

export const ImageContainer = ({
    style = {},
    imageUrl = null,
    alt = "image",
}: ImageContainerProps) => {
    return (
        <div className="item-image-container" style={style}>
            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt={alt}
                    className="item-image"
                />
            ) : (
                <div className="item-image-placeholder" />
            )}
        </div>
    )
}